import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_3 = ["disabled", "onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 5v14M6 13l6 6 6-6" })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "›", -1)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 19V5M6 11l6-6 6 6" })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", null, "›", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M4 8h13l-3-3M20 16H7l3 3" })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", null, "›", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBlockCurrencySelect = _resolveComponent("SharedBlockCurrencySelect")!
  const _component_SharedBlockCurrencyPair = _resolveComponent("SharedBlockCurrencyPair")!
  const _component_Vue3Marquee = _resolveComponent("Vue3Marquee")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WalletMain = _resolveComponent("WalletMain")!
  const _component_WalletHistory = _resolveComponent("WalletHistory")!
  const _component_WalletApplications = _resolveComponent("WalletApplications")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('wrapper'))
    }, [
      (_ctx.walletRepo.list.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.b('currency-section'), "currency-section"])
          }, [
            _createVNode(_component_SharedBlockCurrencySelect, {
              "buy-rate": _ctx.selectedPairBuyRate,
              "sell-rate": _ctx.selectedPairSellRate,
              onPairChanged: _ctx.handlePairChanged
            }, null, 8, ["buy-rate", "sell-rate", "onPairChanged"]),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.b('pairs'), { 'with-animation': _ctx.shouldAnimate }])
            }, [
              _createVNode(_component_Vue3Marquee, {
                duration: _ctx.shouldAnimate ? 30 : 0,
                pauseOnHover: true,
                gap: 20
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pairsWithRates, (pair) => {
                    return (_openBlock(), _createBlock(_component_SharedBlockCurrencyPair, {
                      key: pair.currency_id_from + pair.currency_id_to,
                      pair: pair,
                      "currency-map": _ctx.currencyMap
                    }, null, 8, ["pair", "currency-map"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["duration"])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('heading'))
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: _normalizeClass(_ctx.b('title'))
          }, _toDisplayString(_ctx.$t("Кошелек")), 3),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('subtitle'))
          }, _toDisplayString(_ctx.$t("Мультивалютные счета, обмен и заявки в одном месте")), 3)
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('status'))
        }, [
          _hoisted_1,
          _createTextVNode(_toDisplayString(_ctx.$t("Счета обновляются в реальном времени")), 1)
        ], 2)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.b('hero')),
        style: _normalizeStyle(_ctx.heroSpotStyle),
        onPointermove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleHeroPointerMove && _ctx.handleHeroPointerMove(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('spot')),
          "aria-hidden": "true"
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('hero-copy'))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('eyebrow'))
          }, [
            _hoisted_2,
            _createTextVNode(_toDisplayString(_ctx.$t("Общий баланс · эквивалент")) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.heroCurrency), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('balance'))
          }, [
            (_ctx.displayedFiatSymbol)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(_ctx.b('balance-symbol'))
                }, _toDisplayString(_ctx.displayedFiatSymbol), 3))
              : _createCommentVNode("", true),
            _createElementVNode("strong", null, _toDisplayString(_ctx.displayedBalanceInteger), 1),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.b('balance-fraction'))
            }, _toDisplayString(_ctx.displayedBalanceFraction), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('balance-tabs'))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heroCurrencies, (currency) => {
              return (_openBlock(), _createElementBlock("button", {
                key: currency,
                class: _normalizeClass(_ctx.b('balance-tab', { active: currency === _ctx.heroCurrency })),
                disabled: _ctx.isHeroCurrencyLoading,
                onClick: ($event: any) => (_ctx.handleHeroCurrency(currency))
              }, _toDisplayString(currency), 11, _hoisted_3))
            }), 128))
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('hero-actions'))
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.b('hero-action', { primary: true })),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDeposit && _ctx.handleDeposit(...args)))
          }, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t("Пополнить")), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t("Карта, крипто, перевод")), 1)
            ]),
            _hoisted_5
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.b('hero-action')),
            disabled: !_ctx.hasWalletBalance,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleWithdrawal && _ctx.handleWithdrawal(...args)))
          }, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t("Вывести")), 1),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t("На карту или кошелёк")), 1)
            ]),
            _hoisted_8
          ], 10, _hoisted_6),
          _createVNode(_component_router_link, {
            class: _normalizeClass(_ctx.b('hero-action')),
            to: { name: 'application' }
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("Обменять")), 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.$t("Курс live")) + " · " + _toDisplayString(_ctx.pairsWithRates.length) + " " + _toDisplayString(_ctx.$t("пар")), 1)
              ]),
              _hoisted_10
            ]),
            _: 1
          }, 8, ["class"])
        ], 2)
      ], 38),
      _createVNode(_component_WalletMain),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('group'))
      }, [
        _createVNode(_component_WalletHistory, {
          history: _ctx.depositWithdrawalHistory,
          onDeposit: _ctx.handleDeposit
        }, null, 8, ["history", "onDeposit"]),
        _createVNode(_component_WalletApplications, { history: _ctx.applicationHistory }, null, 8, ["history"])
      ], 2)
    ], 2),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isModalShow)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedModal), {
              key: 0,
              class: _normalizeClass(_ctx.b('modal')),
              modal: _ctx.walletRepo.modal,
              onUpdate: _ctx.loadData,
              onClose: _ctx.closeModal
            }, null, 40, ["class", "modal", "onUpdate", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}